// frontend/src/pages/Settings.tsx

import { useAuthStore } from '../store/authStore';
import { ProfileInfoForm } from '../components/settings/ProfileInfoForm';
import { AvatarSelectorForm } from '../components/settings/AvatarSelectorForm';
import { NotificationSettings } from '../components/settings/NotificationSettings';
import { PasswordChangeForm } from '../components/settings/PasswordChangeForm';
import { JoinClassroomCard } from '../components/settings/JoinClassroomCard';
import '../styles/settings.css';

export function SettingsPage() {
  const profile = useAuthStore((s) => s.profile);
  const session = useAuthStore((s) => s.session);
  const fetchProfile = useAuthStore((s) => s.fetchProfile);

  if (!profile) return <div className="courses-loading">Yükleniyor...</div>;

  return (
    <div className="settings-page">
      <header className="settings-header">
        <h1>Ayarlar ⚙️</h1>
        <p>Hesap ve platform tercihlerini yönet</p>
      </header>

      <div className="grid grid-2">
        <ProfileInfoForm profile={profile} userEmail={session?.user.email} onSaved={fetchProfile} />

        <div>
          <AvatarSelectorForm userId={profile.id} currentStyle={profile.avatar_style} />
          <NotificationSettings userId={profile.id} preferences={profile.notification_preferences} />
        </div>
      </div>

      <PasswordChangeForm />

      <JoinClassroomCard />
    </div>
  );
}
